import { Content } from "antd/lib/layout/layout";
import React from "react";
//import { useDispatch } from "react-redux";
import UpdatePassword from "../../../components/Public/UpdatePassword/UpdatePassword";
//import { openModalLogin } from "../../../redux/aspirante/aspiranteDucks";

export const UpdatePage = () => {
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(openModalLogin());

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <div>
      <Content>
        <UpdatePassword />
      </Content>
    </div>
  );
};
